export const AccessDenied = {
  title: 'Access denied. User is not authorized to access',
  type: 'warning',
} as const;

export const UsedParametersToGenerate = {
  title:
    'After clicking "Generate SAS Token" you will get a token with parameters listed below',
  type: 'info',
} as const;

export const TokenCannotBeGenerated = {
  title: 'Token can not be regenerated. Contact your administrator.',
  type: 'warning',
} as const;

export const CopySasToken = {
  title:
    'Please copy the SAS token value displayed below to store it in a secure location. Once this station is closed, this value will not be retrievable again.',
  type: 'warning',
} as const;
